import { Currency } from '@sequencehq/api'
import {
  IconPlus,
  IndigoIndigo60,
  Primary13SemiBold,
  SimpleTableInput,
  Flex
} from '@sequencehq/core-components'
import { FC } from 'react'
import { ValidationError } from '@sequencehq/utils'
import { PriceEditorPercentageTier } from 'common/drawers/PricingEditor/domain'
import { usePercentageTierWithLimitsTableInput } from './usePercentageTierWithLimitsTableInput'

type PercentageTierWithLimitsTableInputProps = {
  onChange: (value: PriceEditorPercentageTier[]) => void
  value: PriceEditorPercentageTier[]
  isDisabled: boolean
  currency: Currency
  validationErrors: ValidationError[]
}

export const PercentageTierWithLimitsTableInput: FC<
  PercentageTierWithLimitsTableInputProps
> = props => {
  const { fieldConfig, addNewTier } =
    usePercentageTierWithLimitsTableInput(props)

  return (
    <>
      <SimpleTableInput
        {...fieldConfig}
        data-testid="priceEditor.percentageTiersWithLimit"
      />
      <Flex justifyContent="center" marginTop="8px">
        <Flex
          {...Primary13SemiBold}
          width="fit-content"
          color={IndigoIndigo60}
          onClick={() => addNewTier()}
          _hover={{ opacity: 0.7 }}
          cursor="pointer"
          padding="4px 0"
          alignItems="center"
          data-testid="priceEditor.percentageTiersWithLimit.addTier"
          gap="4px"
        >
          <IconPlus /> Add another tier
        </Flex>
      </Flex>
    </>
  )
}
